const routePolicies = Object.freeze({
  Account: {
    isEnabled: (config) => config?.ACCOUNT?.enabled !== false,
    registeredOnly: true,
  },
  PasswordReset: {
    registeredOnly: true,
  },
  AddressBook: {
    isEnabled: (config) => config?.ADDRESS?.enabled !== false,
    registeredOnly: true,
  },
  EditAddress: {
    isEnabled: (config) => config?.ADDRESS?.enabled !== false,
    registeredOnly: true,
  },
  CreateAddress: {
    isEnabled: (config) => config?.ADDRESS?.enabled !== false,
    registeredOnly: true,
  },
  EditCustomer: {
    isEnabled: (config) => config?.CUSTOMER_DATA?.editable !== false,
    registeredOnly: true,
  },
  CustomerCard: {
    isEnabled: (config) => config?.CUSTOMER_CARD?.enabled !== false,
    registeredOnly: true,
  },
  TopUp: {
    isEnabled: (config) => config?.CUSTOMER_CARD?.topUp?.enabled !== false,
    registeredOnly: true,
  },
  TopUpPayment: {
    isEnabled: (config) => config?.CUSTOMER_CARD?.topUp?.enabled !== false,
    registeredOnly: true,
  },
  AutoTopUp: {
    isEnabled: (config) => config?.CUSTOMER_CARD?.autoTopUp?.enabled !== false,
    registeredOnly: true,
  },
  OrderHistory: {
    isEnabled: (config) => config?.ORDER_HISTORY?.enabled !== false,
    registeredOnly: true,
  },
  TransactionHistory: {
    isEnabled: (config) => config?.TRANSACTION_HISTORY?.enabled !== false,
    registeredOnly: true,
  },
  StudentAccounts: {
    isEnabled: (config) => config?.STUDENT_ACCOUNTS?.enabled !== false,
    registeredOnly: true,
  },
  RegisterChild: {
    isEnabled: (config) => config?.STUDENT_ACCOUNTS?.enabled !== false,
    registeredOnly: true,
  },
  OrderMenuParameters: {
    isEnabled: (config) => config?.ORDER?.enabled !== false,
  },
  MealPlanParameters: {
    isEnabled: (config) => config?.MEAL_PLAN?.enabled !== false,
  },
});

function getRoutePolicy(routeName) {
  if (typeof routeName !== 'string' || !routeName) {
    return null;
  }

  return routePolicies[routeName] || null;
}

export function isGuestRestrictedRouteName(routeName) {
  return Boolean(getRoutePolicy(routeName)?.registeredOnly);
}

export function canAccessRouteName(authStore, config, routeName) {
  if (typeof routeName !== 'string' || !routeName) {
    return false;
  }

  const policy = getRoutePolicy(routeName);
  if (!policy) {
    return true;
  }

  if (typeof policy.isEnabled === 'function' && !policy.isEnabled(config)) {
    return false;
  }

  if (policy.registeredOnly && authStore?.isGuest) {
    return false;
  }

  return true;
}

export function getAuthenticatedHomeRouteName(config, authStore) {
  const defaultRouteName = config?.DEFAULT_START_PAGE?.enabled
    ? config.DEFAULT_START_PAGE.name
    : 'Dashboard';

  if (!canAccessRouteName(authStore, config, defaultRouteName)) {
    return 'Dashboard';
  }

  return defaultRouteName || 'Dashboard';
}

export function getSafeAuthenticatedRedirect(authStore, config, routeName, routeParams = null, routeQuery = null) {
  const canUseRequestedRoute = canAccessRouteName(authStore, config, routeName);
  const name = canUseRequestedRoute
    ? routeName
    : getAuthenticatedHomeRouteName(config, authStore);

  return {
    name,
    params: canUseRequestedRoute ? (routeParams || {}) : {},
    query: canUseRequestedRoute ? (routeQuery || {}) : {},
  };
}

